<template>
  <div id="cooperateinkage">
    <div class="mt-4">
      <template>
        <van-button
          type="info"
          size="small"
          class="w-25"
          round
          @click="pushUserInfo"
          >添 加</van-button
        >
      </template>
      <div>
        <el-form
          label-width="35%"
          label-position="left"
          class="m-4 text-left"
          v-for="(item, index) in userList"
          :key="index"
        >
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-user"></i>
              姓名
            </template>
            <template>{{ item.UserName }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-map-marker"></i>
              职务
            </template>
            <template>{{ item.DutyName }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw el-icon-mobile-phone"></i>
              手机号
            </template>
            <template>{{ item.UserPhone }}</template>
          </el-form-item>
          <el-form-item size="mini" v-if="item.UserBase64Photo">
            <template slot="label">
              <i class="fa fa-fw el-icon-camera"></i>
              照片
            </template>
            <template><img :src="item.UserBase64Photo" class="avatar"/></template>
          </el-form-item>
          <el-form-item size="mini">
            <van-button
              type="info"
              size="small"
              @click="
                getUserInfo(
                  item.UserID
                )
              "
              >编 辑</van-button
            >
            <van-button
              type="danger"
              style="margin-left: 10px"
              size="small"
              @click="removeUser(item.UserID)"
              >删 除</van-button
            >
          </el-form-item>
        </el-form>
        <div class="m-4 pb-4"></div>
      </div>
    </div>
    <!-- 添加人员弹出框 -->
    <el-dialog
      title="添加保密室值班人员"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
      :destroy-on-close="true"
      z-index="100"
    >
      <span>
        <el-form label-width="40%" label-position="left" class="m-4 text-left">
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              姓名
            </template>
            <template>
              <el-input type="text" v-model="userInfo.UserName" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              职务
            </template>
            <template>
              <el-input type="text" v-model="userInfo.DutyName" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              手机号
            </template>
            <template>
              <el-input type="text" v-model="userInfo.UserPhone" size="mini"></el-input>
            </template>
          </el-form-item>
          <template>
            <div style="text-align: center;">
              <div class="user-photo">
                <el-upload
                  class="avatar-uploader"
                  :action="getDutyUserPhotoUpdateUrl()"
                  :show-file-list="false"
                  :data="fileParam"
                  :on-success="handleAvatarSuccess"
                  :on-progress="handleProgress"
                  :before-upload="beforeAvatarUpload"
                  :on-error="errorHandler"
                >
                  <p style="font-size: 14px;">上传照片</p>
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" style="margin-left: 25%;"/>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <p style="width:72%;margin-left: 15%;font-size: 14px;">请上传值班人近期免冠正面标准证件照。</p>
                </el-upload>
              </div>
            </div>
          </template>
        </el-form>
      </span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="preserve">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 編輯彈窗 -->
    <el-dialog
      title="编辑保密室值班人员"
      :visible.sync="dialogShow"
      width="90%"
      :before-close="handleClose"
      :destroy-on-close="true"
      z-index="100"
    >
      <span>
        <el-form label-width="40%" label-position="left" class="m-2 text-left">
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              姓名
            </template>
            <template>
              <el-input
                type="text"
                v-model="userInfo.UserName"
                size="mini"
              ></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              职务
            </template>
            <template>
              <el-input
                type="text"
                v-model="userInfo.DutyName"
                size="mini"
              ></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              手机号
            </template>
            <template>
              <el-input
                type="text"
                v-model="userInfo.UserPhone"
                size="mini"
              ></el-input>
            </template>
          </el-form-item>
          <template>
            <div style="text-align: center;">
              <div class="user-photo">
                <el-upload
                  class="avatar-uploader"
                  :action="getDutyUserPhotoUpdateUrl()"
                  :show-file-list="false"
                  :data="fileParam"
                  :on-success="handleAvatarSuccess"
                  :on-progress="handleProgress"
                  :before-upload="beforeAvatarUpload"
                  :on-error="errorHandler"
                >
                  <p style="font-size: 14px;">上传照片</p>
                  <img v-if="imageUrl" :src="imageUrl" class="avatar" style="margin-left: 25%;"/>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <p style="width:72%;margin-left: 15%;font-size: 14px;">请上传值班人近期免冠正面标准证件照。</p>
                </el-upload>
              </div>
            </div>
          </template>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="setUserInfo">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 加载数据时显示遮罩层 -->
    <van-overlay :show="overlayshow">
      <div class="wrapper">
        <van-loading vertical>工作任务加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// 引入 image-conversion
import * as imageConversion from "image-conversion";
import { Dialog } from "vant";
export default {
  name: "dutyuser",
  data () {
    return {
      imageUrl: "",
      fileParam: {},
      userInfo: {
        UserID: "",
        UserName: "",
        UserPhoto: "",
        UserPhone: "",
        DutyName: "" //职务
      },
      dialogVisible: false,
      dialogShow: false, //編輯彈窗是否顯示
      overlayshow: false, // 遮罩层
    };
  },
  created () {
    this.fetchData();
    this.completeBtnAttribute.tips = "需要先添加考务值班人员信息后上报状态";
    // this.verifiupdateData();
  },
  watch: {},
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  methods: {
    fetchData () {
      this.userList = [];
      this.apiGetDutyUserList (
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID
        },
        this,
        res => {
          this.userList=res.data;
          this.$forceUpdate()
        }
      );
      this.verifiupdateData();
    },
    // 添加按鈕  显示弹窗
    pushUserInfo () {
      this.userInfo.UserID = "";
      this.userInfo.UserName = "";
      this.userInfo.UserPhoto = "";
      this.userInfo.UserPhone = "";
      this.userInfo.DutyName = "";
      this.imageUrl = "";
      this.dialogVisible = true;
    },
    // 編輯按鈕
    getUserInfo (UserID) {
      this.dialogShow = true;
      this.apiGetDutyUserInfo(
        {
          WorkID: this.getWork().WorkID,
          UserID: UserID
        },
        this,
        res => {
          this.imageUrl = res.data.UserBase64Photo;
          this.userInfo = res.data;
        }
      );
    },
    // 添加值班人员  保存按鈕
    preserve () {
      if (this.userInfo.UserName == "") {
        Dialog.alert({
          title: "提示",
          message: "姓名不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userInfo.DutyName == "") {
        Dialog.alert({
          title: "提示",
          message: "职务不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userInfo.UserPhone == "") {
        Dialog.alert({
          title: "提示",
          message: "手机号不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userInfo.UserPhoto == "") {
        Dialog.alert({
          title: "提示",
          message: "照片不能为空"
        }).then(() => {
          // on close
        });
      } else {
        this.overlayshow = true; // 显示遮罩层
        this.apiAddDutyUserInfo(
          {
            WorkID: this.getWork().WorkID,
            SplitProcessID: this.SplitProcessID,
            UserName: this.userInfo.UserName,
            DutyName: this.userInfo.DutyName,
            UserPhoto: this.userInfo.UserPhoto,
            UserPhone: this.userInfo.UserPhone
          },
          this,
          res => {
            this.overlayshow = false; // 显示遮罩层
            if (res.code == 20000) {
              this.dialogVisible = false;
              this.userInfo.UserName = "";
              this.userInfo.UserPhoto = "";
              this.userInfo.UserPhone = "";
              this.userInfo.DutyName = "";
              this.$message({
                message: res.message,
                type: "success"
              });
              this.fetchData();
            } else {
              this.$toast(res.message);
            }
            if (res.code == 50000) {
              this.dialogVisible = false;
              this.$message.error(res.message);
              this.fetchData();
              return;
            }
          }
        );
      }
    },
    // 编辑工作人员  保存按鈕
    setUserInfo () {
      if (this.userInfo.DutyName == "") {
        Dialog.alert({
          title: "提示",
          message: "职务不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userInfo.UserPhone == "") {
        Dialog.alert({
          title: "提示",
          message: "手机号不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userInfo.UserName == "") {
        Dialog.alert({
          title: "提示",
          message: "姓名不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userInfo.UserPhoto == "") {
        Dialog.alert({
          title: "提示",
          message: "照片不能为空"
        }).then(() => {
          // on close
        });
      } else {
        this.apiSetDutyUserInfo(
          {
            WorkID: this.getWork().WorkID,
            AreaID: this.userInfo.AreaID,
            UserName: this.userInfo.UserName,
            UserPhone: this.userInfo.UserPhone,
            DutyName: this.userInfo.DutyName,
            UserPhoto: this.userInfo.UserPhoto,
            UserID: this.userInfo.UserID
          },
          this,
          res => {
            console.log("res.code:" + res.code)
            if (res.code == 20000) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.fetchData();
              this.dialogShow = false;
              this.userInfo.UserID = "";
              this.userInfo.UserName = "";
              this.userInfo.UserPhoto = "";
              this.userInfo.UserPhone = "";
              this.userInfo.DutyName = "";
            } else {
              this.$toast(res.message);
            }
            if (res.code == 50000) {
              this.$message.error(res.message);
              this.fetchData();
              return;
            }
          }
        );
      }
    },
    // 刪除工作人員
    removeUser (userID) {
      Dialog.confirm({
        title: "提示",
        message: "此操作将永久删除, 是否继续?"
      })
        .then(() => {
          this.apiDelDutyUserInfo(
            { WorkID: this.getWork().WorkID, UserID: userID },
            this,
            res => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.fetchData();
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleClose () {
      this.dialogVisible = false;
      this.dialogShow = false;
      this.userInfo.UserID = "";
      this.userInfo.UserName = "";
      this.userInfo.UserPhoto = "";
      this.userInfo.UserPhone = "";
      this.userInfo.DutyName = "";
    },
    verifiupdateData () {
      this.apiAllowreportDutyUser(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID
        },
        this,
        res => {
          if (res.data == 1) {
            this.completeBtnAttribute.disabled = false;
          } else {
            this.completeBtnAttribute.disabled = true;
          }
        }
      );
    },
    errorHandler (err, file, fileList) {
      // eslint-disable-next-line no-console
      console.log("上传文件出错。", err, file, fileList);
      return true;
    },
    //upload组件上传成功后回调事件
    handleAvatarSuccess (res, file) {
      // eslint-disable-next-line no-console
      console.log("soijfdshisfdihsfd", res);
      if (res.code == 20000) {
        this.$notify({ type: "success", message: "照片上传成功。" });
        this.imageUrl = URL.createObjectURL(file.raw);
        this.userInfo.UserPhoto = res.data.FileUrl
      } else {
        this.$toast(res.message);
      }
    },
    handleProgress (event, file, fileList) {
      // eslint-disable-next-line no-console
      console.log('上传进度', event, file, fileList)
    },
    //upload组件验证数据内容
    beforeAvatarUpload (file) {
      if(this.userInfo.UserPhone == "" || this.userInfo.UserPhone == null){
        this.$message.error("请填写基本信息后上传照片!");
        return false;
      }
      if(this.userInfo.UserPhone.length != 11){
        this.$message.error("请填写正确手机号后上传照片!");
        return false;
      }
      this.fileParam = {
        WorkID: this.getWork().WorkID,
        UserPhone: this.userInfo.UserPhone
      };
      console.log("file.size: " + file.size/1024)
      //图片校验
      const isJPG = file.type === "image/jpeg";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
        return isJPG;
      }
      // 主要通知
      // eslint-disable-next-line no-console
      console.log("弹出文件上传提示");
      this.$notify({ type: "success", message: "照片正在上传..." });
      // 判断图片文件是否需要压缩（图片不大于4m,宽度不大于2000）
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let isLt2M = file.size / 1024 / 1024 > 4; // 判定图片大小是否小于4MB
        // 这里需要计算出图片的长宽
        let img = new Image();
        img.onload = function () {
          file.width = img.width; // 获取到width放在了file属性上
          file.height = img.height; // 获取到height放在了file属性上
          let valid = img.width > 2000; // 图片宽度大于2000
          // 这里我只判断了图片的宽度,compressAccurately有多个参数时传入对象
          if (valid || isLt2M) {
            // eslint-disable-next-line no-console
            console.log("图片处理 imageConversion", imageConversion);
            imageConversion
              .compressAccurately(file, {
                size: 400,
                width: 2000,
              })
              .then((res) => {
                // console.log(33, res)
                resolve(res);
              });
          } else resolve(file);
        };
        // 需要把图片赋值
        img.src = _URL.createObjectURL(file);
      });
    }
  }
};
</script>

<style scoped>
.el-dialog__body {
  padding: 1px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.user-photo {
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  margin: 20px auto;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>